import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { FeatureFlagKey } from '../services/feature-flags/feature-flag.constant';
import { FeatureFlagService } from '../services/feature-flags/feature-flag.service';

@Pipe({ name: 'featureFlag' })
export class FeatureFlagPipe implements PipeTransform {

    constructor(private readonly featureFlagService: FeatureFlagService) {}

    transform(name: string | FeatureFlagKey): Observable<boolean> {
        return this.featureFlagService.isEnabled$(name);
    }
}
